/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';

import { Stack } from '@atlaskit/primitives/compiled';
import type { AuditLogEventData } from '@atlassian/audit-logs-common';

import { ActorSection } from './sections/actor-section';
import { ChangeComparisonSection } from './sections/change-comparison-section';
import { LocationSection } from './sections/location-section';
import { SummarySection } from './sections/summary-section';
import { UnitSection } from './sections/unit-section';

export interface DetailsPanelProps {
	event: AuditLogEventData;
}

export const DetailsPanel = ({ event }: DetailsPanelProps): JSX.Element => {
	return (
		<Stack space="space.300">
			<SummarySection event={event} />
			<ActorSection actor={event?.actor} />
			<LocationSection location={event?.location} />
			<UnitSection unit={event?.unit} />
			{/* This section is exclusive to Confluence & Jira */}
			{event?.oldValue !== undefined && event?.newValue !== undefined && (
				<ChangeComparisonSection event={event} />
			)}
		</Stack>
	);
};
